import React from 'react'

import { separateByCategoryId, sortAndReturnSelectedReplies, toDateFormat } from '../_helpers/pdfHelpers.js'
import { useChildrenServiceOrders } from '../_load/ChildrenServiceOrdersLoader.js'
import { useServiceOrder } from '../_load/ServiceOrderLoader.js'
import TableWrapper from './sections/tables/TableWrapper.js'
import Identifications from './sections/Identifications.js'
import View from '../../../../components/pdf/View.js'
import Introduction from './sections/Introduction.js'
import Orientation from './sections/Orientation.js'
import ActionPlan from './sections/ActionPlan.js'
import Conclusion from './sections/Conclusion.js'
import Inventory from './sections/Inventory.js'
import Cover from './sections/Cover.js'
import NP2 from './sections/NP2.js'
import NP from './sections/NP.js'

const Content = () => {
  const parentServiceOrder = useServiceOrder()
  const childrenServiceOrder = useChildrenServiceOrders()

  const childrenReplies = childrenServiceOrder.filter(item => item.checklist.id === 15).map(item => item.replies)

  const sortedChildrenReplies = childrenReplies.map(item => {
    return sortAndReturnSelectedReplies([...item])
  })

  const parentServiceOrderReplies = parentServiceOrder?.replies

  const completedDateTime = parentServiceOrder.events.find(item => item.status.id === 8).eventDate
  const formatCompletedDate = toDateFormat(completedDateTime, 'DD [de] MMMM [de] YYYY')

  const sortedParentReplies = sortAndReturnSelectedReplies([...parentServiceOrderReplies])

  const place = parentServiceOrder.place.name
  const address = parentServiceOrder.place.fieldValues.find(item => item?.field?.type === 'address')?.value?.search
  const CNAE = parentServiceOrder.place.fieldValues.find(item => item?.id === 9)?.value
  const CNPJ = parentServiceOrder.place.fieldValues.find(item => item?.id === 10)?.value

  const placeData = { formatCompletedDate, place, address, CNAE, CNPJ }

  const allData = [sortedParentReplies, ...sortedChildrenReplies].map(item => separateByCategoryId(item))

  return (
    <>
      <Cover place={place} />
      <Identifications data={placeData} />
      <View pageBreakAfter>
        <Introduction />
        <NP />
        <NP2 />
      </View>
      <Inventory />
      <ActionPlan />
      <TableWrapper data={allData} placeData={placeData} />
      <Orientation />
      <Conclusion />
    </>
  )
}

export default Content
